import React from "react";
import RegistrationForm from "../components/features/register/RegistrationForm";
import SEO from "../components/common/SEO";

export default function Register() {
  const registerSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://acem-fes.com/inscription#webpage",
        "url": "https://acem-fes.com/inscription",
        "name": "Rejoindre l'ACEM Fès — Formulaire de Recensement et d'Adhésion",
        "description": "Formulaire officiel de recensement et d'adhésion pour les étudiants et stagiaires comoriens à Fès. Rejoignez la communauté ACEM Fès.",
        "inLanguage": "fr-FR",
        "isPartOf": {
          "@type": "WebSite",
          "@id": "https://acem-fes.com/#website",
          "url": "https://acem-fes.com/",
          "name": "ACEM Fès"
        }
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://acem-fes.com/inscription#breadcrumb",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Accueil",
            "item": "https://acem-fes.com/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Rejoindre l'association",
            "item": "https://acem-fes.com/inscription"
          }
        ]
      }
    ]
  };

  return (
    <div className="max-w-4xl mx-auto py-8 px-4 animate-fade-in space-y-6">
      <SEO
        title="Rejoindre l'association – Formulaire de recensement"
        description="Formulaire officiel de recensement pour les étudiants et stagiaires comoriens résidant à Fès. Rejoignez l'ACEM Fès."
        canonical="/inscription"
        jsonLd={registerSchema}
      />
      <div className="text-center space-y-2">
        <h1 className="font-title text-3xl sm:text-4xl font-extrabold text-acem-primary-dark">
          Formulaire de recensement
        </h1>
        <p className="text-sm sm:text-base text-acem-muted max-w-xl mx-auto leading-relaxed">
          Enregistrez-vous dans la base de données officielle de l'ACEM Fès.<br />
          <strong className="text-acem-primary font-bold">Important :</strong> Seuls les Comoriens résidant à Fès sont autorisés à remplir ce formulaire.
        </p>
      </div>

      <RegistrationForm />
    </div>
  );
}
